import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const WorkflowList = withSafeSuspense(lazy(
  async () => ({ default: (await import('./workflow_list')).WorkflowList })
))
